import { Box, Image, Stack, Text } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage } from "react-intl";
import { AccompaniementAndAdvises } from "../../components/AccompaniementAndAdvises";
import { CenteredContent } from "../../components/CenteredContent";
import { ContactBand } from "../../components/ContactBand";
import { CourbetBlock } from "../../components/CourbetBlock";
import { ExpertiseAreas } from "../../components/ExpertiseAreas";
import { GoogleReviewBand } from "../../components/GoogleReviewBand";
import { InterventionAreas } from "../../components/InterventionAreas";
import { fadeUp, Reveal } from "../../components/Reveal";

/**
 * @typedef {object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/Post").Post[]>>} swrResponseArticleExpertiseList
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/Post").Post[]>>} swrResponsePageList
 */
/**
 * @param {Props} props
 */
export function Home({ swrResponseArticleExpertiseList, swrResponsePageList }) {
  return (
    <Box>
      <CenteredContent maxWidth="1920px">
        <Box>
          <Box position="relative">
            <Image
              width="auto"
              height="full"
              minHeight="573px"
              objectFit="cover"
              src={generateFrontPath({
                id: "@front.internal-assets",
                parameters: {
                  filePath: "landing/background.png",
                },
                includeBasePath: true,
              })}
              alt=""
              loading="lazy"
            />

            <CenteredContent>
              <Box position="absolute" top="50%" transform="translateY(-50%)">
                <Stack spacing="1.5rem" px={{ base: ".62rem", xl: 0 }}>
                  <Reveal variants={fadeUp}>
                    <Text
                      variant="h1"
                      color="white"
                      width={{ base: "auto", md: "70%" }}>
                      <FormattedMessage defaultMessage="Notre équipe d’experts après sinistre vous accompagne" />
                    </Text>
                  </Reveal>

                  <Reveal variants={fadeUp}>
                    <Text
                      variant="h2"
                      color="white"
                      width={{ base: "auto", md: "65%" }}>
                      <FormattedMessage
                        defaultMessage="Face aux compagnies d’assurance,
faites-vous conseiller et assister 24h/24 et 7j/7"
                      />
                    </Text>
                  </Reveal>
                </Stack>
              </Box>
            </CenteredContent>
          </Box>

          <GoogleReviewBand />

          <Reveal variants={fadeUp}>
            <ExpertiseAreas
              swrResponseArticleExpertiseList={swrResponseArticleExpertiseList}
            />
          </Reveal>

          <Reveal variants={fadeUp}>
            <CourbetBlock />
          </Reveal>

          <Reveal variants={fadeUp}>
            <AccompaniementAndAdvises
              swrResponsePageList={swrResponsePageList}
            />
          </Reveal>
        </Box>
      </CenteredContent>

      <Reveal variants={fadeUp}>
        <InterventionAreas />
      </Reveal>

      <ContactBand />
    </Box>
  );
}
